import {type List} from 'immutable';

import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type CreamTypes} from './types';

const domain = 'MODALS/APPLY_CREAM';

export const {action: show} = createAction(`${domain}/SHOW`, (childIds: string[]) => ({
    childIds,
}));

export const {
    action: applyCream,
    success: applyCreamSuccess,
    failed: applyCreamFailure,
} = createAction(
    `${domain}/CREAM`,
    (childIds: List<string>, creamType: CreamTypes, sunProtectionFactor: number | undefined) => ({
        childIds,
        creamType,
        sunProtectionFactor,
    }),
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));
